import { render } from "./UploadFormImages.vue?vue&type=template&id=61863174&scoped=true"
import script from "./UploadFormImages.vue?vue&type=script&lang=js"
export * from "./UploadFormImages.vue?vue&type=script&lang=js"

import "./UploadFormImages.vue?vue&type=style&index=0&id=61863174&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61863174"]])

export default __exports__